import LFO from 'modulators/LFO.js';
import Tone from 'tone';
import ParameterContext from 'effects/ParameterContext.js';

class LFOTrack {
    constructor(sequencerEngine, lfosTrack, mixSession, number) {
        this.store = sequencerEngine.store;
        this.sequencerEngine = sequencerEngine;
        this.number = number;
        this.lfo = new LFO(
            sequencerEngine,
            mixSession,
            new ParameterContext().forLFOTrack(this, lfosTrack),
            number);
        this.lfo.lfoMin = -100;
        this.lfo.lfoMax  = 100;
    }

    start(time) {
        this.lfo.start(time);
    }

    stop() {
        this.lfo.stop();
    }

    getName() {
        return 'LFO ' + this.number;
    }

    getJson() {
        return this.lfo.getJson();
    }
}

export default LFOTrack;
